const config = {
  WS_URL: process.env.REACT_APP_WS_URL,
  AXIOS_BASE_URL: process.env.REACT_APP_AXIOS,
};

export default config;
